import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';



class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.support-inbox.views.QuoteSupportInboxTable.';

  public static readonly quoteNumber = `${Id.prefix}quoteNumber`;
  public static readonly quoteTitle = `${Id.prefix}quoteTitle`;
  public static readonly client = `${Id.prefix}client`;
  public static readonly ticketTitle = `${Id.prefix}ticketTitle`;
  public static readonly author = `${Id.prefix}author`;
  public static readonly requestType = `${Id.prefix}requestType`;
  public static readonly status = `${Id.prefix}status`;
  public static readonly dateSubmitted = `${Id.prefix}dateSubmitted`;
  public static readonly lastModified = `${Id.prefix}lastModified`;
  public static readonly dateResolved = `${Id.prefix}dateResolved`;
  public static readonly resolution = `${Id.prefix}resolution`;
  public static readonly ticketOwner = `${Id.prefix}ticketOwner`;
}

export class LangQuoteSupportInboxTable {
  private constructor() {}

  public static quoteNumber(): string {
    return interpolate(Id.quoteNumber);
  }
  public static quoteTitle(): string {
    return interpolate(Id.quoteTitle);
  }
  public static client(): string {
    return interpolate(Id.client);
  }
  public static ticketTitle(): string {
    return interpolate(Id.ticketTitle);
  }
  public static author(): string {
    return interpolate(Id.author);
  }
  public static requestType(): string {
    return interpolate(Id.requestType);
  }
  public static status(): string {
    return interpolate(Id.status);
  }
  public static dateSubmitted(): string {
    return interpolate(Id.dateSubmitted);
  }
  public static lastModified(): string {
    return interpolate(Id.lastModified);
  }
  public static dateResolved(): string {
    return interpolate(Id.dateResolved);
  }
  public static resolution(): string {
    return interpolate(Id.resolution);
  }
  public static ticketOwner(): string {
    return interpolate(Id.ticketOwner);
  }
}

export class QuoteSupportInboxTableModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.quoteNumber, "{{glossary 'quote'}} No.", 'Column header for quote number');
    register.add(Id.quoteTitle, "{{glossary 'quote'}} Title", 'Column header for quote title');
    register.add(Id.client, "{{glossary 'client'}}", 'Column header for client');
    register.add(Id.ticketTitle, 'Ticket Title', 'Column header for ticket title');
    register.add(Id.author, "{{glossary 'author'}}", 'Column header for author');
    register.add(Id.requestType, 'Request Type', 'Column header for request type');
    register.add(Id.status, 'Status', 'Column header for status');
    register.add(Id.dateSubmitted, 'Date Submitted', 'Column header for date submitted');
    register.add(Id.lastModified, 'Last Modified', 'Column header for last modified');
    register.add(Id.dateResolved, 'Date Resolved', 'Column header for date resolved');
    register.add(Id.resolution, 'Resolution', 'Column header for resolution');
    register.add(Id.ticketOwner, 'Ticket Owner', 'Label for ticket owner filter');
  }
}
